// import { NgModule } from '@angular/core'
// import { BrowserModule } from '@angular/platform-browser';
// import { LoginComponent } from './login';
// import { RegisterComponent } from './register';
// import { ForgotPasswordComponent } from './forgotPassword';
// import { appRoutingModule } from './../app.routing';
// import { FormsModule } from '@angular/forms';
// import { ResetPasswordComponent } from './resetPassword';
// import { PrivacyStatementComponent } from './privacyStatement';
// import { OptoutRemindersComponent } from './optoutReminders';
// import { CommonModule } from '@angular/common';

// @NgModule({
//   declarations: [
//     LoginComponent,
//     RegisterComponent,
//     ForgotPasswordComponent,
//     ResetPasswordComponent,
//     PrivacyStatementComponent,
//     OptoutRemindersComponent
//   ],
//   imports: [
// 		BrowserModule,
// 		appRoutingModule,
//     FormsModule,
//     CommonModule
// 	]
// })
// export class AuthenticationModule {}



import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { appRoutingModule } from './../app.routing';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { ForgotPasswordComponent } from './forgotPassword';
import { ResetPasswordComponent } from './resetPassword';
import { PrivacyStatementComponent } from './privacyStatement';
import { OptoutRemindersComponent } from './optoutReminders';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PrivacyStatementComponent,
    OptoutRemindersComponent
  ],
  imports: [
    BrowserModule,       // Required for DOM rendering
    CommonModule,        // Required for Angular template directives
    FormsModule,         // Required for ngModel & ngSubmit
    appRoutingModule
  ]
})
export class AuthenticationModule {}

